"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selection = void 0;
const actions = __importStar(require("../../../../../shared/store/action_constants"));
function setRecord(state, { payload }) {
    // handle first time select and multi select
    if (!state || !state.recordRanges || payload.length > 1) {
        return {
            recordRanges: payload,
        };
    }
    // 1. single record toggle
    // 2. don't select all condition
    if ((state.recordRanges.length === 1 && payload[0] === state.recordRanges[0]) || payload.length === 0) {
        return null;
    }
    const result = state.recordRanges.filter(item => item !== payload[0]);
    if (result.length === state.recordRanges.length)
        result.push(payload[0]);
    return {
        recordRanges: result,
    };
}
/**
 * it is different method for column from record , select whole column, will set the first cell of the column as active cell
 * so activeCell and fieldRanges will appear together
 * no longer judge whether it is a single column or multi column here,
 * because it needs to be judged according to the shift key, so the choice is to handle the data when mouseDown
 *
 * for example: if you press shift, click on the column header that has been selected will keep the original state,
 * without pressing the shift key, clicking on the selected column header will not operate.
 * @param state
 * @param param1
 * @returns
 */
function setFieldRanges(_state, { payload }) {
    const init = {
        fieldRanges: payload,
    };
    return init;
}
const selection = (state = null, action) => {
    switch (action.type) {
        case actions.SET_SELECTION:
            return Object.assign(Object.assign({}, state), action.payload);
        case actions.SET_ACTIVE_CELL:
            return action.payload;
        case actions.SET_RECORD_SELECTION:
            return setRecord(state, action);
        case actions.CLEAR_SELECTION_BUT_KEEP_CHECKED_RECORD:
            return {
                recordRanges: state === null || state === void 0 ? void 0 : state.recordRanges,
            };
        case actions.CLEAR_SELECTION:
            return null;
        case actions.SET_FIELD_RANGES:
            return setFieldRanges(state, action);
        case actions.SET_FILL_HANDLE_STATUS:
            return Object.assign(Object.assign({}, state), action.payload);
        default:
            return state;
    }
};
exports.selection = selection;
//# sourceMappingURL=selection.js.map